import React from "react";
import { Box, Popover, Typography } from "@material-ui/core";

export default function AtColorPalette({
    style,
    colors,
    value,
    onChange,
    disabled,
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    function onChangeColor(color) {
        if (!disabled) {
            onChange(color);
            setAnchorEl(null);
        }
    }

    const handleClick = (event) => {
        if (!disabled) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
        <>
            <Box
                style={{
                    ...style,
                    backgroundColor: value,
                    borderStyle: "solid",
                    borderColor: "#a6a6a6",
                    borderWidth: 1,
                }}
                onClick={handleClick}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box
                    style={{
                        maxWidth: 140,
                        height: "auto",
                        padding: 10,
                    }}
                >
                    <Typography
                        variant="body1"
                        style={{ fontWeight: "bold", marginBottom: 5 }}
                    >
                        Seleccionar color
                    </Typography>
                    <Box display="flex" flexWrap="wrap" justifyContent="center">
                        {colors.map((color, idx) => (
                            <Box key={idx} style={{ padding: 2 }}>
                                <Box
                                    width={25}
                                    height={25}
                                    onClick={() => onChangeColor(color)}
                                    style={{
                                        backgroundColor: color,
                                    }}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Popover>
        </>
    );
}
